import React, { useEffect, useMemo, useState } from "react";
import { Loader2 } from "lucide-react";
import { useParams } from "react-router-dom";
import { useMarketing, SMSTemplate } from "../../../context/MarketingContext";
import { fetchSmsTemplateById } from "../../../services/marketingTemplatesApi";
import { SMSTemplateForm } from "./SMSTemplateForm";

const EditSMSTemplatePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const { smsTemplates } = useMarketing();

  const fromList = useMemo(
    () => (id ? smsTemplates.find((t) => t.id === id) : undefined),
    [id, smsTemplates],
  );

  const [resolved, setResolved] = useState<SMSTemplate | null | undefined>(undefined);

  useEffect(() => {
    if (!id) {
      setResolved(null);
      return;
    }
    if (fromList) {
      setResolved(fromList);
      return;
    }
    let cancelled = false;
    setResolved(undefined);
    fetchSmsTemplateById(id)
      .then((row) => {
        if (!cancelled) setResolved(row ?? null);
      })
      .catch(() => {
        if (!cancelled) setResolved(null);
      });
    return () => {
      cancelled = true;
    };
  }, [id, fromList]);

  return (
    <div className="p-4 lg:p-6">
      <div className="mb-4">
        <h2 className="text-base lg:text-lg font-semibold text-gray-900">
          Edit SMS Template
        </h2>
        <p className="text-xs lg:text-sm text-gray-500">
          Update the text of your SMS template and keep within the character limit.
        </p>
      </div>
      {resolved === undefined && (
        <div className="flex flex-col items-center justify-center py-16 gap-3 text-gray-500">
          <Loader2 className="w-10 h-10 text-[#885ABB] animate-spin" />
          <p className="text-sm">Loading template…</p>
        </div>
      )}
      {resolved === null && (
        <p className="text-sm text-red-600">SMS template not found.</p>
      )}
      {resolved && <SMSTemplateForm template={resolved} />}
    </div>
  );
};

export default EditSMSTemplatePage;

